import * as React from 'react';
import { StockPositionDetailsFeeFragment } from './__generated__/StockPositionDetailsFeeFragment';
import translate, { InjectedTranslateProps, Translated } from 'shared/utils/translate';
import { Fee } from 'components/PositionDetailsModal/components/Fee';
import { TotalFee } from 'components/PositionDetailsModal/components/Fees';

interface Props {
  transaction: StockPositionDetailsFeeFragment;
}

type FeesContentProps = { t: Translated; transaction: StockPositionDetailsFeeFragment };

type Enhanced = Props & InjectedTranslateProps;

function FeesContent({ t, transaction }: FeesContentProps) {
  switch (transaction.operationType) {
    case 'BUY':
      return <Fee title={t('Enter commission value')}>{transaction.commissions}</Fee>;
    case 'SELL':
      return <Fee title={t('Selling commission value')}>{transaction.commissions}</Fee>;
    default:
      return null;
  }
}

function Fees({ transaction, t }: Enhanced) {
  return (
    <TotalFee
      totalFeeAmount={transaction.commissions}
      fees={<FeesContent t={t} transaction={transaction} />}
    />
  );
}

export default translate(Fees);
